import type { CSSProperties, ReactNode } from "react"
import { getAccessibleTextColorForBackgroundColor } from "ui-tools"
import { useCurrentCompanyContext } from "../CurrentCompanyProvider"

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const {
    currentCompany: { companyStarColor, companyButtonColor },
  } = useCurrentCompanyContext()

  const style = {
    "--company-star-color": companyStarColor,
    "--company-button-background-color": companyButtonColor,
    "--company-button-text-color":
      getAccessibleTextColorForBackgroundColor(companyButtonColor),
  } as CSSProperties

  return <div style={style}>{children}</div>
}
